import { clsx } from 'clsx'
import type { Timeframe } from '../types'

interface TimeframeSelectorProps {
  selected: Timeframe
  onChange: (tf: Timeframe) => void
}

const timeframes: { value: Timeframe; label: string }[] = [
  { value: '1m', label: '1m' },
  { value: '5m', label: '5m' },
  { value: '15m', label: '15m' },
  { value: '30m', label: '30m' },
  { value: '1h', label: '1H' },
  { value: '4h', label: '4H' },
  { value: '1d', label: '1D' },
  { value: '1w', label: '1W' },
  { value: '1M', label: '1M' },
]

export function TimeframeSelector({ selected, onChange }: TimeframeSelectorProps) {
  return (
    <div className="flex items-center bg-kit-darker rounded-lg p-1 gap-0.5">
      {timeframes.map(({ value, label }) => (
        <button
          key={value}
          onClick={() => onChange(value)}
          className={clsx(
            'px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200',
            selected === value
              ? 'bg-kit-accent text-black'
              : 'text-gray-400 hover:text-white hover:bg-kit-card'
          )}
        >
          {label}
        </button>
      ))}
    </div>
  )
}
